import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import './index.css';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/Layout';
import StudyPage from './pages/StudyPage';
import AddWordsPage from './pages/AddWordsPage';
import WordListPage from './pages/WordListPage';
import DashboardPage from './pages/DashboardPage';
import { Toaster } from './components/ui/sonner';

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<StudyPage />} />
            <Route path="/add" element={<AddWordsPage />} />
            <Route path="/list" element={<WordListPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="bottom-right" />
    </ThemeProvider>
  );
}
